// extracted by mini-css-extract-plugin
export default {"input":"InputMaterial_input__23us6","Mui-focused":"InputMaterial_Mui-focused__Qqa6k"};